import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import * as publicApi from '../api/publicClient';
import { useSite } from '../context/SiteContext';
import { SITE_NAME } from '../config/site';
import SeoHead from '../components/SeoHead';
import ElifHakanInvitation from './invitations/ElifHakan';

export default function DigitalInvitationPage() {
  const { slug } = useParams();
  const { siteName } = useSite();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setNotFound(false);
      try {
        const invitation = await publicApi.getDigitalInvitation(slug);
        if (!cancelled) setData(invitation);
      } catch {
        if (!cancelled) setNotFound(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [slug]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <SeoHead
          title={`Davetiye | ${SITE_NAME}`}
          description="Kişisel dijital davetiye."
          robots="noindex, nofollow"
        />
        Yükleniyor…
      </div>
    );
  }

  if (notFound || !data) {
    return <Navigate to="/" replace />;
  }

  const coupleTitle =
    data?.landing?.title ||
    [data?.couple?.bride, data?.couple?.groom].filter(Boolean).join(' & ') ||
    'Dijital davetiye';

  return (
    <>
      <SeoHead
        title={`${coupleTitle} | ${SITE_NAME}`}
        description="Kişisel dijital davetiye sayfası."
        robots="noindex, nofollow"
      />
      <ElifHakanInvitation data={data} siteName={siteName} />
    </>
  );
}
